import { 
  getQboIntegrationHasConnected as getQboIntegrationHasConnectedApi,
  getQboIntegrationConnectedUrl as getQboIntegrationConnectedUrlApi,
  getQboIntegrationConnected as getQboIntegrationConnectedApi,
  qboInvoiceSend,
  sendQboCustomer,
  listQboCustomer as listQboCustomerApi,
  listCommandCustomer as listCommandCustomerApi,
  updateLinkCustomerWithQbo as updateLinkCustomerWithQboApi,
  autoSyncCustomerWithQbo as autoSyncCustomerWithQboApi,
} from "@/api/quickbooks";
import Vue from 'vue'
const state = {
  namespaced: true,
  state: {
    qboIntegrationHasConnected: false,
    qboIntegrationConnectedUrl: "",
    disconnectFlag: false,
    originTypeStore:"",
    qboCustomerList:[],
    commandCustomerList:[],
    customerTableLoading:false,
    customerTableQboinfoLoading:false,
    invoiceData: []
  },
  mutations: {
    SET_QBO_INTEGRATION_HAS_CONNECTTTED(state, flag) {
      state.qboIntegrationHasConnected = flag;
    },
    SET_QBO_INTEGRATION_CONNECTTTED_URL(state, url) {
      state.qboIntegrationConnectedUrl = url;
    },
    SET_DISCONNECTTTED_FLAG(state, flag) {
      state.disconnectFlag = flag;
    },
    SET_ORIGIN_TYPE_STORE(state, type) {
      state.originTypeStore = type;
    },
    SET_CUSTOMER_TABLE_QBOINFO_LOADING(state, data) {
      state.customerTableQboinfoLoading = data;
    },
    SET_QBO_CUSTOMER_LIST(state, data) {
      state.qboCustomerList = data;
    },
    SET_COMMAND_CUSTOMER_LIST(state, data) {
      state.commandCustomerList = data;
    },
    SET_CUSTOMER_TABLE_LOADING(state, data){
      state.customerTableLoading = data
    },
    SET_iNVOICE_DATA(state, data) {
      state.invoiceData = data
    }
  },
  actions: {
    setInvoiceData({ commit }, data) {
      commit('SET_iNVOICE_DATA', data)
    },
    getQboIntegrationHasConnected({ commit }) {
      return getQboIntegrationHasConnectedApi().then(
        (result) => {
          try {
            if (result.code == 200) {
              commit(
                "SET_QBO_INTEGRATION_HAS_CONNECTTTED",
                result.data.isConnect
              );
              return Promise.resolve(result);
            }
          } catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getQboIntegrationConnectedUrl({ commit }, data) {
      return getQboIntegrationConnectedUrlApi(data).then(
        (result) => {
          try {
            if (result.code == 200) {
              commit("SET_QBO_INTEGRATION_CONNECTTTED_URL", result.data);
              sessionStorage.setItem('qboIntegrationConnectedUrlStorage',result.data)
              return Promise.resolve(result);
            }
          } catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getQboIntegrationConnected({ commit }, data) {
      let parms = {
        redirectUrl: data.redirectUrl,
        code: data.code,
        realmId: data.realmId,
        state: data.state,
      };
      return getQboIntegrationConnectedApi(parms).then(
        (result) => {
          try {
            if (result.code == 200) {
              commit(
                "SET_QBO_INTEGRATION_HAS_CONNECTTTED",
                result.data.isConnect
              );
              commit();
            }
          } catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    async sendQboCustomerApi({ state }, data) {
      try {
        
        console.log(state);
        const res = await qboInvoiceSend(data);
        let result = res.res.data
        if(result.code == 200) {
          let resultMessage = res.res.data.data
          if(resultMessage.isSuccess && resultMessage.failNum === 0) {
            Vue.prototype.$message.success(`Invoice sent successfully`)
          }
          if(resultMessage.isSuccess && resultMessage.failNum > 0) {
            Vue.prototype.$message.success(`${resultMessage.successNum } invoices sent successfully,${resultMessage.failNum } failed`)
          }
          if(!resultMessage.isSuccess) {
            Vue.prototype.$message.error('Failed to send Invoice')
          }
        } else {
          Vue.prototype.$message.error(result.message || 'Service error, please try again')
        }
        return await Promise.resolve(result);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    getQboCustomerList({ commit }) {
      commit("SET_CUSTOMER_TABLE_QBOINFO_LOADING",true)
      return listQboCustomerApi().then(
        (result) => {
          try {
            commit("SET_CUSTOMER_TABLE_QBOINFO_LOADING",false) 
            commit("SET_QBO_CUSTOMER_LIST", result.data)
            return Promise.resolve(result);
          } catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getCommandCustomerList({ commit }, data) {
      commit("SET_CUSTOMER_TABLE_LOADING",true)
      return listCommandCustomerApi(data).then(
        (result) =>{ 
          try {
            commit("SET_CUSTOMER_TABLE_LOADING",false) 
            commit("SET_COMMAND_CUSTOMER_LIST", result.data)
            return Promise.resolve(result);
          }  catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    sendRealQboCustomerApi(_,data){
      return sendQboCustomer(data).then(
        (res) => {
          return Promise.resolve(res);    
        } 
      );
    },
    autoSyncCustomerWithQbo() {
      return autoSyncCustomerWithQboApi().then(
        () => {
          return Promise.resolve();    
        } 
      );
    },
    updateLinkCustomerWithQbo(_,data) {
      return updateLinkCustomerWithQboApi(data).then(
        () => {
          return Promise.resolve();          
        } 
      );
    },
  },
  getters: {
    qboIntegrationHasConnected: (state) => state.qboIntegrationHasConnected,
    qboIntegrationConnectedUrl: (state) => state.qboIntegrationConnectedUrl,
    disconnectFlag: (state) => state.disconnectFlag,
    originTypeStore: (state) => state.originTypeStore,
    qboCustomerList: (state) => state.qboCustomerList,
    commandCustomerList: (state) => state.commandCustomerList,
    customerTableLoading: (state) => state.customerTableLoading,
    customerTableQboinfoLoading: (state) => state.customerTableQboinfoLoading,
    invoiceData: (state) => state.invoiceData,
  },
};

export default state;
